export default __webpack_public_path__ + "static/media/img8.68873bb4.png";